export const ESTATE_TYPE_LIST = [
    {
      name: '基础物业服务',
      suggest: '·秩序维护·绿化清洁·工程维护·管家服务',
    },
    {
      name: '智慧物业平台',
      suggest: '·物业ERP·智能巡检·在线报修/缴费',
    },
    {
      name: '社区多元化经经营',
      suggest: '·房屋租售/装修·社区商业/家政',
    },
    {
      name: '社区活动',
      suggest: '·常态·公益·教育·运动',
    },
  ];
  // 
  export const ESTATE_SYSTEM_LIST = [
    {
      img: require('../../assets/images/icon01.png'),
      name: '新引擎',
    },
    {
      img: require('../../assets/images/icon02.png'),
      name: '新互联',
    },
    {
      img: require('../../assets/images/icon03.png'),
      name: '新平台',
    },
    {
      img: require('../../assets/images/icon04.png'),
      name: '新关怀',
    },
    {
      img: require('../../assets/images/icon05.png'),
      name: '新帮手',
    },
    {
      img: require('../../assets/images/icon06.png'),
      name: '新纽带',
    },
  ]